export enum FunctionsReportXmlNodes {
    EIC_MARKET_DOCUMENT = "EIC_MarketDocument",
    EIC_MARKET_DOCUMENT_NAMESPACE = "urn:iec62325.351:tc57wg16:451-n:eicdocument:1:2",
    MRID = "mRID",
    REVISION_NUMBER = "revisionNumber",
    TYPE = "type",
    SENDER_MARKET_PARTICIPANT_ID = "sender_MarketParticipant.mRID",
    CODING_SCHEME_ATTR = "codingScheme",
    SENDER_MARKET_PARTICIPANT_TYPE = "sender_MarketParticipant.marketRole.type",
    RECEIVER_MARKET_PARTICIPANT_ID = "receiver_MarketParticipant.mRID",
    RECEIVER_MARKET_PARTICIPANT_TYPE = "receiver_MarketParticipant.marketRole.type",
    CREATED_DATE_TIME = "createdDateTime",

    FUNCITON_ELEMENT = "function",
    CODE = "code",
    NAME = "name",
    STATUS = "status",
    DEFINITION = "definition",
    CREATION_DATE = "creation_Date",
    DEACTIVATION_DATE = "deactivation_Date",
    VALID_IN_MARKET = "valid_In_Market",
}
    